module.exports = __webpack_public_path__ + "static/media/table-red.a4d7c279.png";